import { NgModule, Injectable } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { Observable } from 'rxjs';

import { CoreDialogModule } from '../core/core.module';
import { ScreenSizeService } from '../core/core';

import { SettingsDialogComponent, SettingsDialogOptions } from './settings.dialogcomponent';

@Injectable()
export class SettingsDialogService {
    smallMediaSize: boolean;

    constructor(private matDialog: MatDialog, private mediaChange: ScreenSizeService) {
        this.smallMediaSize = this.mediaChange?.ScreenSize?.IsSmallDisplay || false;
    }

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open

    Open(options?: SettingsDialogOptions): Observable<boolean> {
        const self = this;
        const dlgoptions: SettingsDialogOptions = {
            disableClose: true,
            data: {
                TitleText: 'Settings',
                MessageText: '',
                OKText: 'OK',
                ...options,
            },
            maxHeight: '85vh',
            // width: options?.width || '80vw',
        };

        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.panelClass = ['confdialog', 'smalldialogpanel'];
        } else {
            dlgoptions.panelClass = ['confdialog'];
        }

        const openHandle = this.matDialog.open<SettingsDialogComponent>(SettingsDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }

    // #endregion
}

@NgModule({
    imports: [CoreDialogModule, MatButtonModule, MatDialogModule, MatIconModule, MatSlideToggleModule],
    declarations: [SettingsDialogComponent],
    exports: [SettingsDialogComponent],
    providers: [SettingsDialogService],
})
export class SettingsDialogModule {}
